import Update from 'immutability-helper';

export default class TabletsModalActions {
    constructor(component) {
        this.component = component;
    }

    changeData(value) {
        const state = Update(this.component.state, {
            modalCriteria: {
                minimumData: { $set: value }
            }
        });
        this.component.setState(state);
    }

    changeSpend(min, max) {
        const state = Update(this.component.state, {
            modalCriteria: {
                common: {
                    minimumSpend: { $set: min },
                    maximumSpend: { $set: max }
                }
            }
        });
        this.component.setState(state);
    }

    changeSelectedSuppliers(suppliers, customerType, networkIds) {
        const state = Update(this.component.state, {
            modalCriteria: {
                common: {
                    suppliers: {
                        values: { $set: suppliers }
                    },
                    customerType: { $set: customerType }
                },
                networkIds: { $set: networkIds }
            }
        });
        this.component.setState(state);
    }

    changePrepaidExpiry(min, max) {
        const state = Update(this.component.state, {
            modalCriteria: {
                prepaidExpiryDays: { $set: min },
                maximumPrepaidExpiryDays: { $set: max }
            }
        });
        this.component.setState(state);
    }

    changeCurrentSupplier(value) {
        const state = Update(this.component.state, {
            modalCriteria: {
                common: {
                    currentSupplierShortUrl: { $set: value }
                }
            }
        });
        this.component.setState(state);
    }

    changePlanType(value) {
        if (!value || value === '') {
            value = [];
        } else {
            value = new Array(value);
        }

        const state = Update(this.component.state, {
            modalCriteria: {
                planTypes: { $set: value }
            }
        });
        this.component.setState(state);
    }

    changeSortExpression(expression, descending) {
        const state = Update(this.component.state, {
            modalCriteria: {
                common: {
                    resultsSortExpression: { $set: expression },
                    resultsSortAscending: { $set: !descending }
                }
            }
        });
        this.component.setState(state);
    }

    changeTablet(tabletShortUrl, simOnly, simType) {
        let priceTypes = this.component.state.modalCriteria.tabletPriceTypes;
        if (!tabletShortUrl || tabletShortUrl.length <= 0) {
            priceTypes = [];
        }

        const state = Update(this.component.state, {
            modalCriteria: {
                tabletShortUrl: { $set: tabletShortUrl },
                includeSimOnly: { $set: simOnly },
                simType: { $set: simType },
                tabletPriceTypes: { $set: priceTypes }
            }
        });
        this.component.setState(state);
    }

    changeTabletPriceTypes(selectedPriceTypes, allPriceTypes) {
        let priceTypes = selectedPriceTypes;
        if (priceTypes && priceTypes.length === allPriceTypes.length) {
            priceTypes = [];
        }
        const state = Update(this.component.state, {
            modalCriteria: {
                tabletPriceTypes: { $set: priceTypes }
            }
        });
        this.component.setState(state);
    }

    changeMaxUpfront(value) {
        if (value === -1) value = null;

        const state = Update(this.component.state, {
            modalCriteria: {
                maximumTabletUpfrontCost: { $set: value }
            }
        });
        this.component.setState(state);
    }

    setOtherOptions(options) {
        let state = Update(this.component.state, {
            modalCriteria: {
                common: {
                    maxResultsPerSupplier: { $set: null },
                    includeOffersWithCampaignOnly: { $set: false }
                },
                compareUnthrottledData: { $set: false }
            }
        });

        if (options && options.length > 0) {
            options.forEach(o => {
                if (o === 'single-result') {
                    state = Update(state, {
                        modalCriteria: {
                            common: {
                                maxResultsPerSupplier: { $set: 1 }
                            }
                        }
                    });
                } else if (o === 'deals-only') {
                    state = Update(state, {
                        modalCriteria: {
                            common: {
                                includeOffersWithCampaignOnly: { $set: true }
                            }
                        }
                    });
                } else if (o === 'full-speed-data') {
                    state = Update(state, {
                        modalCriteria: {
                            compareUnthrottledData: { $set: true }
                        }
                    });
                }
            });
        }
        this.component.setState(state);
    }
}
